<p *ngIf="isLocalized" class="fa-pull-right" style="color: gray; font-size: 14px">{{languagesService.selectedLanguage.name}}</p>
<p *ngIf="!isLocalized" class="fa-pull-right" style="color: gray; font-size: 14px" i18n>Not localized</p>


